<div class="aw-dialog" *ngIf="(selectedOrganization$ | async) as selectedOrganization">
  <div class="header-container">
    <div class="aw-dialog-header">Group Settings</div>
  </div>
  <div class="main-container">
    <div class="sidebar">
      <awair-group-list
        style="position: relative; display: block;"
        [groupedDeviceList]="groupedDeviceList"
        [selectedId]="selectedGroupId"
        (selectGroupId)="selectGroupId($event)">
      </awair-group-list>
      <div class="create-group-container">
        <a class="create-group-link" (click)="createGroup(selectedOrganization.token)">
          <object type="image/svg+xml" style="width: 16px; height: 16px; padding: 4px 0px; margin-right: 8px;"
            data="assets/images/group/ic_create.svg">Your browser does not support SVGs</object>
          Create a New Group
        </a>
      </div>
    </div>
    <div class="detail-container">
      <awair-group-detail
        [selectedGroup]="selectedGroup"
        [groupedDeviceList]="groupedDeviceList"
        (addDevice)="addDevice($event, selectedOrganization.token)"
        (assignToGroup)="assignToGroup($event, selectedOrganization.token)"
        (removeFromGroup)="removeFromGroup($event, selectedOrganization.token)"
        (deleteGroup)="deleteGroup($event, selectedOrganization.token)"
        (manageMember)="manageMember($event, selectedOrganization.token)">
      </awair-group-detail>
    </div>
  </div>
  <div class="footer">
    <button class="aw-btn aw-btn-blue" (click)="done()">Done</button>
  </div>
</div>
